import { CapacitorCookies } from '@capacitor/core';
import React from 'react';
import { useHistory } from 'react-router-dom';
import MenuItem from 'reusable-components/navigation/NavigationMenuList/MenuItem';
import { isCordova } from 'utils/platform';
import useAuthStore from '~/authentication/store';
import { useDebugModeStore } from '~/stores/debug';
import { useInAppUpdateStore } from '~/stores/inAppUpdate';

type DebugMenuItemsProps = {};

const DebugMenuItems = (_: DebugMenuItemsProps) => {
  const history = useHistory();
  const { checkForUpdate } = useInAppUpdateStore();
  const { setDebugMode } = useDebugModeStore();
  const handleClearCookies = async () => {
    if (!isCordova()) {
      alert('Clear cookies is only available on Cordova apps.');
      return;
    }
    const confirmDialog = window.confirm(
      'This will clear all cookies and log you out of the app. Are you sure you want to continue?',
    );
    if (!confirmDialog) return;

    useAuthStore.getState().logout();
    await CapacitorCookies.clearAllCookies();
    alert('Cookies cleared. You are now logged out.');
    history.push('/');
  };
  const handleDisableDebugMode = () => {
    setDebugMode(false);
  };

  const handleCheckForAppUpdates = async () => {
    await checkForUpdate({ startWhenAvailable: true, trigger: 'manual' });
  };

  return (
    <>
      <MenuItem text={'Disable Debug Mode'} onClick={handleDisableDebugMode} />
      <MenuItem
        text={'Check for app updates'}
        onClick={handleCheckForAppUpdates}
      />
      {isCordova() && (
        <>
          <MenuItem text={'Clear cookies'} onClick={handleClearCookies} />
        </>
      )}
    </>
  );
};

export default DebugMenuItems;
